<template>
    <div>
        <div class="w_1200 clearfix2 box_mh20">
            <div class="fl black6_text box_pt8 site_th">
                <span class="home_icon icon_public box_mr8"></span>
                <span class="text_m">当前位置：<router-link tag="a" to="/">首页</router-link>
                    <span class="china">&gt;</span><router-link tag="a" :to="'/'+selectedNavEn" v-text="selectedNav"></router-link>
                    <span class="china">&gt;</span><span v-text="selectedNav"></span>详情
                </span>
            </div>
            <div class="fr">
                <Search/>
            </div>
        </div>
        <!--end一行-->

        <div class="clearfix2 box_mt20 w_1200 h_tab">
            <dl class="tab_nav d_tab_nav">
                <dd class="font_18 font_b">
                    <a href="javascript:void(0);" :class="{tab_light:selectedTab==='详细信息'}" @click="selectedTab='详细信息'">详细信息</a>
                    <a href="javascript:void(0);" :class="{tab_light:selectedTab==='竞买信息'}" @click="selectedTab='竞买信息'" v-show="showJmxx">竞买信息</a>
                    <a href="javascript:void(0);" :class="{tab_light:selectedTab==='结果公示'}" @click="selectedTab='结果公示'" v-show="showJggs">结果公示</a>
                </dd>
            </dl>
            <div class="tab_box">
                <div v-show="selectedTab==='详细信息'">
                    <div class="link_div box_c box_mh30 blue_link">
                        <a href="javascript:void(0);" class="item_a box_sizing cd-popup-trigger0">查看出让公告</a>
                        <a href="javascript:void(0);" class="item_a box_sizing cd-popup-trigger1">查看出让须知</a>
                        <a href="javascript:void(0);" class="item_a box_sizing cd-popup-trigger2">查看现场图</a>
                        <a href="javascript:void(0);" class="item_a box_sizing cd-popup-trigger3" style="display:none">查看视频</a>
                        <a href="javascript:void(0);" class="item_a box_sizing cd-popup-trigger4">下载本次挂牌出让文件</a>
                    </div>


                    <table class="list_table_y blue_link box_mt20" v-if="isTdcr">
                        <tbody>
                        <tr>
                            <td colspan="4" style="text-align: center;">
                                <span v-text="detail.zylxText">国有建设用地使用权出让</span>
                            </td>
                        </tr>
                        <tr v-if="selectedNav==='结果公示'">
                            <td colspan="4" style="text-align: center;">
                                挂牌活动已经截止，宗地<span style="color: red;" v-if="detail.zyztText === '流拍'">已</span>
                                <span style="color: red;" v-text="detail.zyztText"></span>
                            </td>
                        </tr>
                        <tr>
                            <th width="15%">交易序号</th>
                            <td width="35%" v-text="detail.jyxh"></td>
                            <th width="15%">挂牌起始时间</th>
                            <td v-text="detail.gpqssj"></td>
                        </tr>
                        <tr>
                            <th>挂牌资源编号</th>
                            <td v-text="detail.zybh"></td>
                            <th>保证金截止时间</th>
                            <td v-text="detail.bzjdzjzsj"></td>
                        </tr>
                        <tr>
                            <th>公告号</th>
                            <td v-text="detail.ggh"></td>
                            <th>挂牌截止时间</th>
                            <td v-text="detail.gpjzsj"></td>
                        </tr>
                        <tr>
                            <th>申购报名时间</th>
                            <td v-text="detail.extData.sgkssj"></td>
                            <th>申购报名截止时间</th>
                            <td v-text="detail.sgjzsj"></td>
                        </tr>
                        <tr>
                            <th>委托方</th>
                            <td v-text="detail.wtf"></td>
                            <th>区域</th>
                            <td v-text="detail.qyText"></td>
                        </tr>
                        <tr>
                            <th>项目名称</th>
                            <td colspan="3" v-text="detail.xmmc"></td>
                        </tr>
                        <tr>
                            <th>使用权面积</th>
                            <td><span v-text="detail.syqmj"></span> 平方米</td>
                            <th>地块亩数</th>
                            <td v-text="detail.dkms"></td>
                        </tr>
                        <tr>
                            <th>建筑面积</th>
                            <td v-text="detail.jzmj || '/'"></td>
                            <th>绿地率</th>
                            <td v-text="detail.ldl"></td>
                        </tr>
                        <tr>
                            <th>规划容积率</th>
                            <td v-text="detail.ghrjl"></td>
                            <th>建筑密度</th>
                            <td v-text="detail.jzmd"></td>
                        </tr>
                        <tr>
                            <th>规划用途</th>
                            <td v-text="detail.xxghyt"></td>
                            <th>出让年限</th>
                            <td v-text="detail.crnx"></td>
                        </tr>
                        <tr>
                            <th>竞买保证金</th>
                            <td><span v-text="detail.jmbzjwy"></span> <span v-text="detail.extData.bzjdw"></span></td>
                            <th>竞购方式</th>
                            <td v-text="detail.jgfsText"></td>
                        </tr>
                        <tr>
                            <th v-show="detail.jgfsCode==='01'">起始价</th>
                            <th v-show="detail.jgfsCode==='02'">房价起始价</th>
                            <th v-show="detail.jgfsCode==='03'">房价起始价</th>
                            <th v-show="detail.jgfsCode==='04'">起始住房面积</th>
                            <th v-show="detail.jgfsCode==='05'">起始住房面积</th>
                            <td><span v-text="detail.qsjwy"></span> <span v-text="detail.jgdwText"></span></td>

                            <th v-show="detail.jgfsCode==='01'">增加幅度</th>
                            <th v-show="detail.jgfsCode==='02'">减少幅度</th>
                            <th v-show="detail.jgfsCode==='03'">增加幅度</th>
                            <th v-show="detail.jgfsCode==='04'">增加幅度</th>
                            <th v-show="detail.jgfsCode==='05'">增加幅度</th>
                            <td><span v-text="detail.zjfdwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr>
                            <th>业务咨询所在地</th>
                            <td colspan="3" v-text="detail.extData.ywzxszd"></td>
                        </tr>
                        <tr>
                            <th>服务咨询联系人</th>
                            <td v-text="detail.extData.fwzxlxr">></td>
                            <th>服务咨询电话</th>
                            <td v-text="detail.extData.fwzxlxdh"></td>
                        </tr>
                        <tr>
                            <th>业务咨询地址</th>
                            <td colspan="3" v-text="detail.extData.ywzxdz"></td>
                        </tr>
                        <tr v-if="detail.zyztText==='已成交'">
                            <th>成交时间</th>
                            <td v-text="detail.cjsj" class="red_text"></td>
                            <th>成交金额</th>
                            <td class="red_text"><span v-text="detail.cjjwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr v-if="detail.zyztText==='已成交'">
                            <th>竞得人</th>
                            <td colspan="3" class="red_text" v-text="detail.jdr"></td>
                        </tr>
                        <tr v-if="detail.zyztText==='流拍'">
                            <th>资源状态</th>
                            <td v-text="detail.zyztText" class="red_text"></td>
                            <th>结束时间</th>
                            <td v-text="detail.jssj" class="red_text"></td>
                        </tr>
                        <tr style="display:none">
                            <th>其他</th>
                            <td colspan="3">
                                <div class="min_h160" v-html="detail.qt"></div>
                            </td>
                        </tr>
                        <tr v-if="detail.bz!==null">
                            <th>备注</th>
                            <td colspan="3">
                                <div class="min_h160" v-html="detail.bz"></div>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <table class="list_table_y blue_link box_mt20" v-else-if="detail.zylxCode==='02'">
                        <tbody>
                        <tr>
                            <td colspan="4" style="text-align: center;">
                                <span>国有建设用地使用权转让</span>
                            </td>
                        </tr>
                        <tr v-if="selectedNav==='结果公示'">
                            <td colspan="4" style="text-align: center;">
                                拍卖活动已经截止，宗地<span style="color: red;" v-if="detail.zyztText === '流拍'">已</span>
                                <span style="color: red;" v-text="detail.zyztText"></span>
                            </td>
                        </tr>
                        <tr>
                            <th width="15%">项目名称</th>
                            <td width="35%" v-text="detail.xmmc"></td>
                            <th width="15%">挂牌起始时间</th>
                            <td v-text="detail.gpqssj"></td>
                        </tr>
                        <tr>
                            <th>项目编号</th>
                            <td v-text="detail.zybh"></td>
                            <th>保证金截止时间</th>
                            <td v-text="detail.bzjdzjzsj"></td>
                        </tr>
                        <tr>
                            <th>公告号</th>
                            <td v-text="detail.ggh"></td>
                            <th>挂牌截止时间</th>
                            <td v-text="detail.gpjzsj"></td>
                        </tr>
                        <tr>
                            <th>申购报名时间</th>
                            <td v-text="detail.extData.sgkssj"></td>
                            <th>申购报名截止时间</th>
                            <td v-text="detail.sgjzsj"></td>
                        </tr>
                        <tr>
                            <th>委托方</th>
                            <td v-text="detail.wtf"></td>
                            <th>区域</th>
                            <td v-text="detail.qyText"></td>
                        </tr>
                        <tr>
                            <th>项目名称</th>
                            <td colspan="3" v-text="detail.xmmc"></td>
                        </tr>
                        <tr>
                            <th>使用权面积</th>
                            <td><span v-text="detail.syqmj"></span> 平方米</td>
                            <th>地块亩数</th>
                            <td v-text="detail.dkms"></td>
                        </tr>
                        <tr>
                            <th>建筑面积</th>
                            <td v-text="detail.jzmj || '/'"></td>
                            <th>出让年限</th>
                            <td v-text="detail.crnx"></td>
                        </tr>
                        <tr>
                            <th>规划用途</th>
                            <td colspan="3" v-text="detail.xxghyt"></td>
                        </tr>
                        <tr>
                            <th>竞买保证金</th>
                            <td colspan="3"><span v-text="detail.jmbzjwy"></span> 元</td>
                        </tr>
                        <tr>
                            <th>起始价</th>
                            <td><span v-text="detail.qsjwy"></span> <span v-text="detail.jgdwText"></span></td>
                            <th>增加幅度</th>
                            <td><span v-text="detail.zjfdwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr>
                            <th>业务咨询所在地</th>
                            <td colspan="3" v-text="detail.extData.ywzxszd"></td>
                        </tr>
                        <tr>
                            <th>服务咨询联系人</th>
                            <td v-text="detail.extData.fwzxlxr">></td>
                            <th>服务咨询电话</th>
                            <td v-text="detail.extData.fwzxlxdh"></td>
                        </tr>
                        <tr>
                            <th>业务咨询地址</th>
                            <td colspan="3" v-text="detail.extData.ywzxdz"></td>
                        </tr>
                        <tr v-if="detail.zyztText==='已成交'">
                            <th>成交时间</th>
                            <td v-text="detail.cjsj" class="red_text"></td>
                            <th>成交金额</th>
                            <td class="red_text"><span v-text="detail.cjjwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr v-if="detail.zyztText==='已成交'">
                            <th>竞得人</th>
                            <td colspan="3" class="red_text" v-text="detail.jdr"></td>
                        </tr>
                        <tr v-if="detail.zyztText==='流拍'">
                            <th>资源状态</th>
                            <td v-text="detail.zyztText" class="red_text"></td>
                            <th>结束时间</th>
                            <td v-text="detail.jssj" class="red_text"></td>
                        </tr>
                        <tr style="display:none">
                            <th>其他</th>
                            <td colspan="3">
                                <div class="min_h160" v-html="detail.qt"></div>
                            </td>
                        </tr>
                        <tr v-if="detail.bz!==null">
                            <th>备注</th>
                            <td colspan="3">
                                <div class="min_h160" v-html="detail.bz"></div>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <table class="list_table_y blue_link box_mt20" v-else-if="detail.zylxCode==='03'">
                        <tbody>
                        <tr>
                            <td colspan="4" style="text-align: center;">
                                <span>采矿权</span>
                            </td>
                        </tr>
                        <tr v-if="selectedNav==='结果公示'">
                            <td colspan="4" style="text-align: center;">
                                挂牌活动已经截止，采矿权<span style="color: red;" v-if="detail.zyztText === '流拍'">已</span>
                                <span style="color: red;" v-text="detail.zyztText"></span>
                            </td>
                        </tr>
                        <tr>
                            <th width="15%" rowspan="2">挂牌资源编号</th>
                            <td width="35%" rowspan="2" v-text="detail.zybh"></td>
                            <th width="15%">挂牌起始时间</th>
                            <td v-text="detail.gpqssj"></td>
                        </tr>
                        <tr>
                            <th>挂牌截止时间</th>
                            <td v-text="detail.gpjzsj"></td>
                        </tr>
                        <tr>
                            <th>公告号</th>
                            <td colspan="3" v-text="detail.ggh"></td>
                        </tr>
                        <tr>
                            <th>矿权位置</th>
                            <td colspan="3" v-text="detail.kqwz"></td>
                        </tr>
                        <tr>
                            <th>矿权范围</th>
                            <td colspan="3" v-text="detail.kqfw"></td>
                        </tr>
                        <tr>
                            <th>矿区面积</th>
                            <td v-text="detail.kqmj + 'km²'"></td>
                            <th>矿种</th>
                            <td v-text="detail.kzmc"></td>
                        </tr>
                        <tr>
                            <th>开采年限</th>
                            <td v-text="detail.kcnxn"></td>
                            <th>开采规模</th>
                            <td v-text="detail.kcgm"></td>
                        </tr>
                        <tr>
                            <th>资源储量</th>
                            <td v-text="detail.zycl"></td>
                            <th>开采方式</th>
                            <td v-text="detail.kcfs"></td>
                        </tr>
                        <tr>
                            <th>起始价</th>
                            <td><span v-text="detail.qsjwy"></span> <span v-text="detail.jgdwText"></span></td>
                            <th>标高</th>
                            <td v-text="detail.bg"></td>
                        </tr>
                        <tr>
                            <th>增加幅度</th>
                            <td><span v-text="detail.zjfdwy"></span> <span v-text="detail.jgdwText"></span></td>
                            <th>保证金截止时间</th>
                            <td v-text="detail.bzjdzjzsj"></td>
                        </tr>
                        <tr v-if="detail.zyztText==='已成交'">
                            <th>成交时间</th>
                            <td v-text="detail.cjsj" class="red_text"></td>
                            <th>成交金额</th>
                            <td class="red_text"><span v-text="detail.cjjwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr v-if="detail.zyztText==='已成交'">
                            <th>竞得人</th>
                            <td colspan="3" class="red_text" v-text="detail.jdr"></td>
                        </tr>
                        <tr v-if="detail.zyztText==='流拍'">
                            <th>资源状态</th>
                            <td v-text="detail.zyztText" class="red_text"></td>
                            <th>结束时间</th>
                            <td v-text="detail.jssj" class="red_text"></td>
                        </tr>
                        <tr>
                            <th>出让人名称</th>
                            <td v-text="detail.extData.crrmc"></td>
                            <th>出让人联系人</th>
                            <td v-text="detail.extData.crrlxr"></td>
                        </tr>
                        <tr>
                            <th>出让人地址</th>
                            <td v-text="detail.extData.crrdz"></td>
                            <th>联系电话</th>
                            <td v-text="detail.extData.crrlxdh"></td>
                        </tr>
                        <tr>
                            <th>其他</th>
                            <td colspan="3">
                                <div class="min_h160" v-html="detail.qt"></div>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <table class="list_table_y blue_link box_mt20" v-else-if="detail.zylxCode==='04'">
                        <tbody>
                        <tr>
                            <td colspan="4" style="text-align: center;">
                                <span>耕地储备指标</span>
                            </td>
                        </tr>
                        <tr v-if="selectedNav==='结果公示'">
                            <td colspan="4" style="text-align: center;">
                                挂牌活动已经截止，耕地储备指标<span style="color: red;" v-if="detail.zyztText === '流拍'">已</span>
                                <span style="color: red;" v-text="detail.zyztText"></span>
                            </td>
                        </tr>
                        <tr>
                            <th width="15%">交易序号</th>
                            <td width="35%" v-text="detail.jyxh"></td>
                            <th width="15%">挂牌起始时间</th>
                            <td v-text="detail.gpqssj"></td>
                        </tr>
                        <tr>
                            <th>挂牌资源编号</th>
                            <td v-text="detail.zybh"></td>
                            <th>保证金截止时间</th>
                            <td v-text="detail.bzjdzjzsj"></td>
                        </tr>
                        <tr>
                            <th>公告号</th>
                            <td v-text="detail.ggh"></td>
                            <th>挂牌截止时间</th>
                            <td v-text="detail.gpjzsj"></td>
                        </tr>
                        <tr>
                            <th>申购报名时间</th>
                            <td v-text="detail.extData.xmjy.sgkssj"></td>
                            <th>申购报名截止时间</th>
                            <td v-text="detail.sgjzsj"></td>
                        </tr>
                        <tr>
                            <th>委托方</th>
                            <td v-text="detail.wtf"></td>
                            <th>区域</th>
                            <td v-text="detail.qyText"></td>
                        </tr>
                        <tr>
                            <th>项目名称</th>
                            <td v-text="detail.xmmc"></td>
                            <th>指标类型</th>
                            <td v-text="detail.extData.xmjy.zblxText"></td>
                        </tr>
                        <tr>
                            <th>耕地储备指标数量</th>
                            <td> <span v-text="detail.extData.xmjy.jysl + ' ' +detail.extData.xmjy.jldwText"></span> </td>
                            <th v-text="detail.extData.xmjy.zjfsCode==='01' ? '最高限价' : '最低限价'"></th>
                            <td v-text="(detail.extData.xmjy.zjfsCode==='01' ? detail.extData.xmjy.zgxj : detail.extData.xmjy.zdxj) + ' 万元'"></td>
                        </tr>
                        <tr>
                            <th>竞买保证金</th>
                            <td v-text="detail.extData.xmjy.bzjwy + ' 万元'"></td>
                            <th>竞价方式</th>
                            <td v-text="detail.extData.xmjy.jjfsText"></td>
                        </tr>
                        <tr>
                            <th>起始价</th>
                            <td><span v-text="detail.qsjwy"></span> 万元</td>
                            <th v-text="detail.extData.xmjy.zjfsCode==='01' ? '增价幅度' : '减价幅度'"></th>
                            <td v-text="(detail.extData.xmjy.zjfsCode==='01' ? detail.extData.xmjy.zjfd : detail.extData.xmjy.jjfd) + ' 万元'"></td>
                        </tr>
                        <tr>
                            <th>出让人名称</th>
                            <td v-text="detail.extData.crrmc"></td>
                            <th>出让人联系人</th>
                            <td v-text="detail.extData.crrlxr"></td>
                        </tr>
                        <tr>
                            <th>出让人地址</th>
                            <td v-text="detail.extData.crrdz"></td>
                            <th>联系电话</th>
                            <td v-text="detail.extData.crrlxdh"></td>
                        </tr>
                        <tr v-if="detail.zyztText==='已成交'">
                            <th>成交时间</th>
                            <td v-text="detail.cjsj" class="red_text"></td>
                            <th>成交金额</th>
                            <td class="red_text"><span v-text="detail.cjjwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr v-if="detail.zyztText==='已成交'">
                            <th>竞得人</th>
                            <td colspan="3" class="red_text" v-text="detail.jdr"></td>
                        </tr>
                        <tr v-if="detail.zyztText==='流拍'">
                            <th>资源状态</th>
                            <td v-text="detail.zyztText" class="red_text"></td>
                            <th>结束时间</th>
                            <td v-text="detail.jssj" class="red_text"></td>
                        </tr>
                        </tbody>
                    </table>

                </div>
                <!--end详细信息-->
                <div v-if="isShowJmxx">
                    <JmxxZrpm v-if="detail.zylxCode === '02' && detail.extData.jyfsCode === '2'" :detail="detail"/>
                    <JmxxZrgp v-else-if="detail.zylxCode === '02' && detail.extData.jyfsCode === '1'" :detail="detail"/>
                    <JmxxCrgp v-else :detail="detail"/>
                </div>
                <div v-else></div>

                <!--end竞买信息-->
                <div v-show="selectedTab==='结果公示'" class="detail_content">
                    <h1 style="text-align: center" v-text="cjgsbt"></h1>
                    <div v-if="detail.jggsnr!==null">
                        <div v-html="detail.jggsnr"></div>
                        <FileDownload :fj-list="jggsFjList" :domian="jggsFjDomain"/>
                    </div>
                    <div class="no-data" style="display: none;" v-else>该栏目暂无数据</div>
                </div>
            </div>
            <!--end标签内容-->
        </div>
        <!--end一行-->

        <!--star_弹框 -->
        <div class="cd-popup">
            <!--is-visible去掉这个样式他就隐藏了,点击 href="javascript:;" class="cd-popup-trigger1"-->
            <div class="cd-popup-container clearfix2">
                <a href="#0" class="cd-popup-close transition_a f_close_btn"></a>
                <!--star内容-->
                <h4 class="blue_bj box_pw20 white_text font_16 f_code_th">查看出让公告</h4>
                <div class="box_mw20 box_pt20">
                    <div class="box_c box_line_d box_pd20">
                        <h3 class="font_22" v-text="cr_title"></h3>
                    </div>
                    <!--end标题-->

                    <div class="h_320 scroll_box box_mt20 d_wen box_mw20 font_16" style="height: 550px;">
                        <div class="box_pr30" v-if="detail.ggnr!==null">
                            <div class="detail_content" v-html="detail.ggnr"></div>
                            <div class="detail_content" v-if="isTdcr">
                                <table style="margin-bottom: 50px;">
                                    <tbody>
                                    <tr>
                                        <td>委托方：</td>
                                        <td v-text="detail.wtf"></td>
                                        <td>区域：</td>
                                        <td v-text="detail.qyText"></td>
                                    </tr>
                                    <tr>
                                        <td>联系电话：</td>
                                        <td v-text="detail.extData.crrlxdh"></td>
                                        <td>应急电话：</td>
                                        <td v-text="detail.extData.yjlxdh"></td>
                                    </tr>
                                    <tr>
                                        <td>联系人：</td>
                                        <td v-text="detail.extData.crrlxr"></td>
                                        <td>联系地址：</td>
                                        <td v-text="detail.extData.crrlxdz"></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="detail_content" v-else-if="detail.zylxCode==='02'">
                                <table style="margin-bottom: 50px;">
                                    <tbody>
                                    <tr>
                                        <td>委托方：</td>
                                        <td v-text="detail.wtf"></td>
                                        <td>区域：</td>
                                        <td v-text="detail.qyText"></td>
                                    </tr>
                                    <tr>
                                        <td>联系电话：</td>
                                        <td v-text="detail.extData.crrlxdh"></td>
                                        <td>应急电话：</td>
                                        <td v-text="detail.extData.yjlxdh"></td>
                                    </tr>
                                    <tr>
                                        <td>联系人：</td>
                                        <td v-text="detail.extData.crrlxr"></td>
                                        <td>联系地址：</td>
                                        <td v-text="detail.extData.crrlxdz"></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="detail_content" v-else-if="detail.zylxCode==='03'">
                                <table style="margin-bottom: 50px;">
                                    <tbody>
                                    <tr>
                                        <td>出让人名称：</td>
                                        <td v-text="detail.extData.crrmc"></td>
                                        <td>出让人联系人：</td>
                                        <td v-text="detail.extData.crrlxr"></td>
                                    </tr>
                                    <tr>
                                        <td>出让人地址：</td>
                                        <td v-text="detail.extData.crrdz"></td>
                                        <td>联系电话：</td>
                                        <td v-text="detail.extData.crrlxdh"></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="detail_content" v-else-if="detail.zylxCode==='04'">
                                <table style="margin-bottom: 50px;">
                                    <tbody>
                                    <tr>
                                        <td>出让人名称：</td>
                                        <td v-text="detail.extData.crrmc"></td>
                                        <td>出让人联系人：</td>
                                        <td v-text="detail.extData.crrlxr"></td>
                                    </tr>
                                    <tr>
                                        <td>出让人地址：</td>
                                        <td v-text="detail.extData.crrdz"></td>
                                        <td>联系电话：</td>
                                        <td v-text="detail.extData.crrlxdh"></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="no-data" style="display: none;" v-else>该栏目暂无数据</div>
                    </div>
                    <!--end内容-->


                </div>
                <!--end内容-->
            </div>
        </div>
        <!--end查看出让公告-->

        <div class="cd-popup1">
            <!--is-visible1去掉这个样式他就隐藏了,点击 href="javascript:;" class="cd-popup-trigger1"-->
            <div class="cd-popup-container1 clearfix2">
                <a href="#0" class="cd-popup-close transition_a f_close_btn"></a>
                <!--star内容-->
                <h4 class="blue_bj box_pw20 white_text font_16 f_code_th">查看出让须知</h4>

                <div class="box_mw20 box_pt20">
                    <div class="box_c box_line_d box_pd20">
                        <h2 class="font_b font_24" v-text="cr_title"></h2>
                        <h3 class="font_22" v-text="xzbt"></h3>
                    </div>
                    <!--end标题-->

                    <div class="h_320 scroll_box box_mt20 d_wen box_mw20 font_16" style="height: 550px;">
                        <div class="box_pr30 detail_content" v-html="detail.xznr" v-if="detail.xznr!==null"></div>
                        <div class="no-data" style="display: none;" v-else>该栏目暂无数据</div>
                    </div>
                    <!--end内容-->


                </div>
                <!--end内容-->
            </div>
        </div>
        <!--end查看出让须知-->

        <div class="cd-popup2">
            <!--is-visible2去掉这个样式他就隐藏了,点击 href="javascript:;" class="cd-popup-trigger2"-->
            <div class="cd-popup-container2 clearfix2">
                <a href="#0" class="cd-popup-close transition_a f_close_btn"></a>
                <!--star内容-->
                <h4 class="blue_bj box_pw20 white_text font_16 f_code_th">查看现场图</h4>

                <div class="box_c box_pt60 box_md40" v-if="fj.pic !== undefined && fj.pic !== null && fj.pic.length<=0" style="height: 750px;">
                    <img src="../assets/images/icon/null_box.png" alt="暂无数据">
                    <h4 class="font_16 black6_text box_mt20">暂无数据</h4>
                </div>
                <!--end暂无数据-->
                <div class="box_c box_pt20" style="height: 750px;" v-else>
                    <Attachment :dataList="fj.pic"/>
                </div>
                <!--end内容-->
            </div>
        </div>
        <!--end查看现场图-->

        <div class="cd-popup3">
            <!--is-visible3去掉这个样式他就隐藏了,点击 href="javascript:;" class="cd-popup-trigger3"-->
            <div class="cd-popup-container3 clearfix2">
                <a href="#0" class="cd-popup-close transition_a f_close_btn"></a>
                <!--star内容-->
                <h4 class="blue_bj box_pw20 white_text font_16 f_code_th">查看视频</h4>

                <div class="box_c box_pt60 box_md40" v-if="fj.video !== undefined && fj.video !== null && fj.video.length<=0" style="height: 750px;">
                    <img src="../assets/images/icon/null_box.png" alt="暂无数据">
                    <h4 class="font_16 black6_text box_mt20">暂无数据</h4>
                </div>
                <!--end暂无数据-->
                <div class="d_video_div box_mt20" style="height: 750px;" v-else>
                    <video :src="fj.video[0].url" controls preload="none"></video>
                </div>
                <!--end内容-->
            </div>
        </div>
        <!--end查看视频-->

        <div class="cd-popup4">
            <!--is-visible4去掉这个样式他就隐藏了,点击 href="javascript:;" class="cd-popup-trigger4"-->
            <div class="cd-popup-container4 clearfix2">
                <a href="#0" class="cd-popup-close transition_a f_close_btn"></a>
                <!--star内容-->
                <h4 class="blue_bj box_pw20 white_text font_16 f_code_th">下载本次挂牌出让文件</h4>
                <div class="box_mt20 box_mw20 scroll_box h_400">
                    <table class="list_table box_c blue_link">
                        <thead>
                        <tr>
                            <th>序号</th>
                            <th>文件名</th>
                            <th>文件类型</th>
                            <th>操作</th>
                        </tr>
                        </thead>
                        <tbody v-if="fj.file !== undefined && fj.file !== null && fj.file.length>0">
                        <tr v-for="(data,index) in fj.file" :key="data.id">
                            <td><span class="num_box blue_bj" v-text="index+1">1</span></td>
                            <td class="box_l" v-text="data.name"></td>
                            <td>公告相关附件</td>
                            <td><a :href="data.url">下载</a></td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                        <tr>
                            <td colspan="10" style="color: #999;display: none">暂无记录</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <!--end内容-->
            </div>
        </div>
        <!--end下载本次挂牌出让文件-->
        <!--end_弹框 -->
    </div>
</template>

<script>
    import {api} from '@/core/api'
    import {getQueryVariable, findKey} from '@/core/common'
    import Attachment from "@/components/Attachment";
    // import Jmxx from "@/components/Jmxx";
    import Search from "@/components/Search";
    import FileDownload from "@/components/FileDownload";
    import JmxxCrgp from "@/components/JmxxCrgp";
    import JmxxZrpm from "@/components/JmxxZrpm";
    import JmxxZrgp from "@/components/JmxxZrgp";

    export default {
        name: "Detail",
        components: {Search, Attachment, FileDownload, JmxxCrgp, JmxxZrpm, JmxxZrgp},
        data() {
            return {
                selectedNav: null,
                nav: {
                    "正在公告": "01",
                    "正在挂牌": "02",
                    "结果公示": "03",
                    "所有挂牌": "04",
                    "全文搜索": "05",
                    "结果待公示": "06",
                },
                selectedNavEn: null,
                navEn: {
                    "zzgg": "01",
                    "zzgp": "02",
                    "jggs": "03",
                    "sygp": "04",
                    "qwss": "05",
                    "zzzs": "06",
                },
                selectedTab: '详细信息',
                detail: {},
                cr_title: "",
                fj: {
                    pic: [],
                    video: [],
                    file: []
                },
                params: {
                    category: "Gtzy",
                    id: null
                },
                cjgsbt: "",
                xzbt: "",
                jggsId: "",
                jggsFjDomain: "",
                jggsFjList: [],
            }
        },
        mounted() {
            this.params.id = getQueryVariable("id");

            const nav = getQueryVariable("nav");
            this.selectedNav = findKey(this.nav, nav);
            this.selectedNavEn = findKey(this.navEn, nav);

            api.getDetailById(this.params).then(response => {
                this.detail = response.data;
                let crnr = this.detail.crnr === null ? '' : this.detail.crnr;
                let crggbh = this.detail.crggbh === null ? '' : this.detail.crggbh;
                this.cr_title = crnr + " " + crggbh;
                this.detail.qt = this.detail.qt === null ? "" : this.detail.qt.replaceAll('\n', '<br />');
                this.detail.bz = this.detail.bz === null ? "" : this.detail.bz.replaceAll('\n', '<br />');
                if (this.detail.zylxCode === "01") {
                    this.cjgsbt = "韶关市公共资源交易中心土地使用权出让结果公示";
                    this.xzbt = "韶关市国有建设用地使用权网上交易须知";
                    this.jggsFjDomain = "Tdsyqcrjggsfj";
                } else if (this.detail.zylxCode === "02") {
                    this.cjgsbt = "韶关市公共资源交易中心土地使用权转让结果公示";
                    this.xzbt = "韶关市国有建设用地使用权网上交易须知";
                    this.jggsFjDomain = "Tdsyqzrpmjggsfj";
                } else if (this.detail.zylxCode === "03") {
                    this.cjgsbt = "韶关市公共资源交易中心矿业权出让结果公示";
                    this.xzbt = "韶关市矿业权网上交易须知";
                    this.jggsFjDomain = "Kyqcrjggsfj";
                } else if (this.detail.zylxCode === "04") {
                    this.cjgsbt = "韶关市公共资源交易中心耕地储备指标结果公示";
                    this.xzbt = "韶关市耕地储备指标网上交易须知";
                    this.jggsFjDomain = "Gdcbzbjyjggsfj";
                    this.cr_title = "韶关市耕地储备指标网上交易公告";
                }else if (this.detail.zylxCode === "05") {
                    this.cjgsbt = "韶关市公共资源交易中心农村集体经营性建设用地使用权出让结果公示";
                    this.xzbt = "韶关市集体建设用地使用权网上交易须知";
                    this.jggsFjDomain = "Tdsyqcrjggsfj";
                }else if (this.detail.zylxCode === "06") {
                    this.cjgsbt = "韶关市公共资源交易中心集体土地使用权出租结果公示";
                    this.xzbt = "韶关市集体土地使用权出租网上交易须知";
                    this.jggsFjDomain = "Tdsyqcrjggsfj";
                }
                const zylx = this.isTdcr ? "01" : this.detail.zylxCode;
                api.getJggsById({zylx: zylx, id: this.detail.jyID}).then(response => {
                    if ("data" in response) {
                        this.jggsId = response.data.id;
                        this.detail.jggsnr = response.data.gsnr;
                        api.getFj({domain: this.jggsFjDomain, id: this.jggsId}).then(response => {
                            this.jggsFjList = response.data
                        })
                    }
                });

            });
            api.getPic({id: this.params.id}).then(response => {
                // this.fj.pic = response.data;
                let pic = [];
                let responseData = response.data;
                responseData.forEach(item => {
                    let data = {
                        id: item.id,
                        url: this.$URL.API + '/api/common/download?domain=GtzyFj&id=' + item.id,
                    };
                    pic.push(data)
                });
                this.fj.pic = pic;
            });
            // api.getVideo({id: this.params.id}).then(response => {
            //     // this.fj.video = response.data
            //     let video = [];
            //     let responseData = response.data;
            //     responseData.forEach(item => {
            //         let data = {
            //             id: item.id,
            //             url: this.$URL.API + '/api/common/download?domain=GtzyFj&id=' + item.id,
            //             thumbnail: this.$URL.API + '/api/common/download?domain=GtzyFj&type=thumbnail&id=' + item.id,
            //         };
            //         video.push(data)
            //     });
            //     this.fj.video = video;
            // });
            api.getFile({id: this.params.id}).then(response => {
                // this.fj.file = response.data;
                let file = [];
                let responseData = response.data;
                responseData.forEach(item => {
                    let data = {
                        id: item.id,
                        url: this.$URL.API + '/api/common/download?domain=GtzyFj&id=' + item.id,
                        name: item.uploadedFileName,
                    };
                    file.push(data)
                });
                this.fj.file = file;
            });
        },
        methods: {},
        computed: {
            isShowJmxx() {
                return this.selectedTab === '竞买信息' && this.detail.jyID;
            },
            showJmxx() {
                return this.selectedNav === '正在挂牌';
            },
            showJggs() {
                return this.selectedNav === '结果公示';
            },
            isTdcr(){
                return this.detail.zylxCode === "01" || this.detail.zylxCode === "05" || this.detail.zylxCode === "06";
            }
        }
    }
</script>

<style scoped>
    .item_a:hover {
        color: #fff;
        background-color: #4293f4;
    }
</style>
<style>

    .detail_content {
        overflow: auto;
    }

    .detail_content table {
        margin: 0 auto;
    }

    .detail_content table td {
        padding: 10px 20px;
    }

    .detail_content table p {
        margin: 0 !important;
        text-indent: 0;
    }

    .detail_content img {
        max-width: 1000px;
    }

    .detail_content pre {
        white-space: pre-wrap; /* css3.0 */
        white-space: -moz-pre-wrap; /* Firefox */
        white-space: -pre-wrap; /* Opera 4-6 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }

    .detail_content h2 {
        font: 24px/1.5 Arial, Lucida, Verdana, Helvetica, sans-serif;
        text-align: center;
        color: rgb(0, 112, 164);
        font-size-adjust: none;
        font-stretch: normal;
    }

    .detail_content p {
        line-height: 24px;
        font-size: 14px;
        margin-bottom: 10px;
    }

    .detail_content b {
        color: rgb(51, 51, 51);
        font-size: 16px;
        font-weight: bold;
    }

    .detail_content li {
        color: rgb(255, 102, 0);
        line-height: 24px;
        font-size: 14px;
    }

    .detail_content a {
        text-decoration: none;
    }

    .detail_content li a {
        text-decoration: none;
    }

    .detail_content li a:hover {
        color: rgb(255, 102, 0);
    }

    .cont_close {
        padding: 10px 20px;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }
</style>
